import React from 'react';
import {Box} from "@mui/material";
import {IconContext} from "react-icons";
import {FaSitemap} from "react-icons/fa";
import {IPeopleArticle} from "../../../../../utils/interfaces/tannery_production/articles/IPeopleArticle";


const getIconsForCustomField = (row: IPeopleArticle, theme: any, t: any) => {
    const icons = [];
    const icon_color = theme.palette.primary.main

    icons.push(
        row.articles.length > 0 &&
        <FaSitemap color={icon_color} title='ARTICLES INSIDE'></FaSitemap>
    );


    return icons;
};

export const customArticleCellRenderer = (rowData: IPeopleArticle, theme: any, t: any) => {
    const icons = getIconsForCustomField(rowData, theme, t);
    return (
        <IconContext.Provider
            value={{size: "1.3rem"}}
        >
            <Box display="flex" sx={{gap: 0.5}}>
                {icons.map((icon, index) => (
                    <span key={index}>{icon}</span>
                ))}
            </Box>
        </IconContext.Provider>

    );
};

export default customArticleCellRenderer;
